import { styled, Link, Avatar, Grid, Typography } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import { Button } from '@totalsoft/rocket-ui';

export const LinkWrapper = styled(Link)(() => ({
  cursor: 'pointer'
}));

export const DirectSettlementAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(2.25),
  height: theme.spacing(2.25),
  backgroundColor: theme.palette.warning.main,
  fontSize: '0.7rem !important'
}));

export const QuotationCard = styled(Card, {
  shouldForwardProp: prop => !['selected', 'disabled', 'isLastModified'].includes(prop)
})(({ theme, selected, disabled, isLastModified }) => ({
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: 'transparent',
  ...(selected && {
    borderColor: theme.palette.primary.main,
    boxShadow: theme.shadows[15]
  }),
  ...(disabled && {
    opacity: 0.7
  }),
  ...(isLastModified && {
    borderStyle: 'dashed',
    borderColor: theme.palette.secondary.main
  })
}));

export const QuotationButton = styled(Button, {
  shouldForwardProp: prop => !['quotationIsSelected'].includes(prop)
})(({ theme, quotationIsSelected }) => ({
  '&.Mui-disabled': {
    backgroundColor: quotationIsSelected ? theme.palette.secondary.main : theme.palette.primary.main,
    color: theme.palette.common.white,
    opacity: 0.7
  }
}));

export const QuotationInsurerContainer = styled(Grid)(() => ({
  flexWrap: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

export const QuotationText = styled(Typography)(() => ({
  whiteSpace: 'nowrap'
}));

export const StyledImage = styled('img')(() => ({
  width: '100%',
  height: 'auto',
  objectFit: 'scale-down',
  maxHeight: '150px'
}));

export const FigureWrapper = styled('figure')(() => ({
  margin: 0
}));

export const CardDetailTitle = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: '1.1rem'
}));

export const InsuranceSummaryContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  [theme.breakpoints.up('md')]: {
    justifyDirection: 'column'
  }
}));

export const InsuranceSummaryItemContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    width: 'unset'
  }
}));
